import { Injectable } from '@angular/core';
import { CanActivate, Router }    from '@angular/router';
import { GlobalServiceService } from './services/global-service.service'
import { LoginService } from './login.service'
import { MatSnackBar } from '@angular/material'
@Injectable({
  providedIn: 'root'
})
export class RouteGuardService implements CanActivate {

  constructor(
    private router: Router,
    private app: GlobalServiceService,
    private login: LoginService,
    private snackBar: MatSnackBar,
    public _global: GlobalServiceService
    ) { }

   canActivate(item) {

    let data=  JSON.parse(localStorage.getItem('userInfo'))
    if (data == undefined) {
    	this.router.navigate(['login'])
    	return false;
    }
    this.app.setLogged(true)

    if (localStorage.getItem("access")) {
      this.login.refreshInfo(data.usuario_id).subscribe((response:any)=>{
        if (response.success) {
          localStorage.setItem('userInfo',JSON.stringify(response.data))
          this.app.setUserInfo(response.data)
          data =  JSON.parse(localStorage.getItem('userInfo'))
        }
      },err=>{
        if (this._global.flagLogsData) {
        console.warn('is it here?', err);
        }
      })

    }


    let menu: any[] = this.app.valueMenu()
    let haveAccess= false
    for (var i = 0; i < menu.length; i++) {
      let found = false
      for (var j = 0; j < data.module.length; j++) {

        if (data.module[j].modulo_id == menu[i].id) {
          menu[i].show = true
          found = true
          let path ='/'+item.url[0].path;
          if (menu[i].route!=undefined) {
            if (menu[i].route == path) {
              haveAccess= true
            }
          }  else{
            for (var c = 0; c < menu[i].childrens.length; c++) {
              let routeArray = menu[i].childrens[c].route.split('/')
              let route ='/'+routeArray[1];
              if (route == path) {
                haveAccess= true
                break;
              }
            }
          }
          break;
        }
      }

      if (!found) {
        menu[i].show = false
        // if(menu[i].id == 13){
        //   menu[i].show = true
        // }
      }
    }

    this.app.setMenu(menu)

    if (!haveAccess) {
      this.showMsg('You have no access to that module')
    }

    return haveAccess;
  }

  showMsg(msg=''){
    this.snackBar.open(msg, 'Cerrar', {
      duration: 2000,
    });
  }
}
